import { Box, BoxProps } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { FaPauseCircle, FaPlayCircle } from "react-icons/fa";

/**
 * Audio Player with play/pause button, given the source audio URL
 * All audio-related updates will be confined to this component, reducing re-rendering costs
 */
export function AudioButton({
  audioUrl,
  ...rest
}: BoxProps & { audioUrl: string }) {
  // Create an audio player and toggle function to allow for playback on the podcast episode
  const [isPlaying, setPlaying] = useState(false);
  function togglePlay() {
    isPlaying ? audioRef.current?.pause() : audioRef.current?.play();
    setPlaying(!isPlaying);
  }
  const audioRef = useRef<HTMLAudioElement>(null);

  return (
    <>
      {/** The audio file sourced here, with preload off (only loads audio on play) */}
      <audio ref={audioRef} preload="none" src={audioUrl} />
      <Box
        as={isPlaying ? FaPauseCircle : FaPlayCircle}
        onClick={togglePlay}
        title={isPlaying ? "Pause" : "Play"}
        {...rest}
      />
    </>
  );
}
